// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AlterarCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/alterar_compromisso
 *
 * Validates input for updating an existing compromisso.
 */
import { registerContract } from './validate'

export interface Agenda_AlterarCompromissoInput {
compromisso_id: number
compromisso_operador_user_id: string
compromisso_orcamento_id: number
compromisso_data_hora_inicio: string
compromisso_data_hora_fim: string
compromisso_forma_pagamento?: number
compromisso_numero_parcelas?: number
compromisso_franquia_id?: number
}

registerContract('Agenda_AlterarCompromissoInput', {
  compromisso_id:               { type: 'number',  required: true },
  compromisso_operador_user_id: { type: 'string',  required: true },
  compromisso_orcamento_id:     { type: 'number',  required: true },
  compromisso_data_hora_inicio: { type: 'string',  required: true },
  compromisso_data_hora_fim:    { type: 'string',  required: true },
  compromisso_forma_pagamento:  { type: 'number',  required: false },
  compromisso_numero_parcelas:  { type: 'number',  required: false },
  compromisso_franquia_id:      { type: 'number',  required: false },
})
